/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_TitleInputs */

const tr_hakkimizda_title = /** @type {(inputs: Hakkimizda_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® ve ShopPanel™`)
};

const en_hakkimizda_title = /** @type {(inputs: Hakkimizda_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® and ShopPanel™`)
};

const de_hakkimizda_title = /** @type {(inputs: Hakkimizda_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® und ShopPanel™`)
};

const ru_hakkimizda_title = /** @type {(inputs: Hakkimizda_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® и ShopPanel™`)
};

/**
* | output |
* | --- |
* | "Emonse® and ShopPanel™" |
*
* @param {Hakkimizda_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_title = /** @type {((inputs?: Hakkimizda_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_title(inputs)
	if (locale === "de") return de_hakkimizda_title(inputs)
	if (locale === "ru") return ru_hakkimizda_title(inputs)
	return tr_hakkimizda_title(inputs)
});